export default "__VITE_ASSET__B6zU15r6__"